import axios from 'axios';

export const UserSettingService = {
    getUserSettingData,
    saveUserSettingData
};

function getUserSettingData(params, cb, errorCb) {
    axios
        .get('/api/SurveyClientData/GetUserSettingData?' + params)
        .then(response => (
            cb(response.data)
        ))
        .catch(error => {
            //console.log(error.response)
            errorCb(error);
        });
}

function saveUserSettingData(params, cb, errorCb) {
    axios
        .post('/api/SurveyClientData/SaveUserSettingData', params)
        .then(response => (
            cb(response.data)
        ))
        .catch(error => {
            console.log(error.response);
            errorCb(error);
        });
}

